/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as PlaygroundRouteImport } from './routes/playground'
import { Route as OnboardingRouteImport } from './routes/onboarding'
import { Route as ErrorRouteImport } from './routes/error'
import { Route as ApiKeyRouteImport } from './routes/api-key'
import { Route as IndexRouteImport } from './routes/index'

const PlaygroundRoute = PlaygroundRouteImport.update({
  id: '/playground',
  path: '/playground',
  getParentRoute: () => rootRouteImport,
} as any)
const OnboardingRoute = OnboardingRouteImport.update({
  id: '/onboarding',
  path: '/onboarding',
  getParentRoute: () => rootRouteImport,
} as any)
const ErrorRoute = ErrorRouteImport.update({
  id: '/error',
  path: '/error',
  getParentRoute: () => rootRouteImport,
} as any)
const ApiKeyRoute = ApiKeyRouteImport.update({
  id: '/api-key',
  path: '/api-key',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/api-key': typeof ApiKeyRoute
  '/error': typeof ErrorRoute
  '/onboarding': typeof OnboardingRoute
  '/playground': typeof PlaygroundRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/api-key': typeof ApiKeyRoute
  '/error': typeof ErrorRoute
  '/onboarding': typeof OnboardingRoute
  '/playground': typeof PlaygroundRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/api-key': typeof ApiKeyRoute
  '/error': typeof ErrorRoute
  '/onboarding': typeof OnboardingRoute
  '/playground': typeof PlaygroundRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths: '/' | '/api-key' | '/error' | '/onboarding' | '/playground'
  fileRoutesByTo: FileRoutesByTo
  to: '/' | '/api-key' | '/error' | '/onboarding' | '/playground'
  id: '__root__' | '/' | '/api-key' | '/error' | '/onboarding' | '/playground'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  ApiKeyRoute: typeof ApiKeyRoute
  ErrorRoute: typeof ErrorRoute
  OnboardingRoute: typeof OnboardingRoute
  PlaygroundRoute: typeof PlaygroundRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/playground': {
      id: '/playground'
      path: '/playground'
      fullPath: '/playground'
      preLoaderRoute: typeof PlaygroundRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/onboarding': {
      id: '/onboarding'
      path: '/onboarding'
      fullPath: '/onboarding'
      preLoaderRoute: typeof OnboardingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/error': {
      id: '/error'
      path: '/error'
      fullPath: '/error'
      preLoaderRoute: typeof ErrorRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/api-key': {
      id: '/api-key'
      path: '/api-key'
      fullPath: '/api-key'
      preLoaderRoute: typeof ApiKeyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  ApiKeyRoute: ApiKeyRoute,
  ErrorRoute: ErrorRoute,
  OnboardingRoute: OnboardingRoute,
  PlaygroundRoute: PlaygroundRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
